<template>
    <div>

    </div>
</template>

<script>
    export default {
        name: "UserMenuAdd",
        data() {
            return {

            };
        },
        mounted(){

        },
        methods: {

        }
    }
</script>

<style scoped>
</style>